module.exports = __webpack_public_path__ + "static/vibetribe-md-382d7f3c7d94e27bce1496b21a24806e.jpg";